
/**
 * --- External Imports ---
 */
import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

/**
 * --- Internal Imports ---
 */
import { GetDocumentStatesByLabel, GetDocumentStatesByLabelResponse } from "@/apis/dtos";
import useGet from "../apis/useGet";

/**
 * --- Hook ---
 */
const getData = (response?: SWRResponse<GetDocumentStatesByLabelResponse, GetDocumentStatesByLabelResponse>) => response?.data?.documentStates;
const getError = (response?: SWRResponse<GetDocumentStatesByLabelResponse, GetDocumentStatesByLabelResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<GetDocumentStatesByLabelResponse, GetDocumentStatesByLabelResponse>) => ({});

const useGetDocumentStatesByLabel = (query?: Partial<GetDocumentStatesByLabel>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new GetDocumentStatesByLabel(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useGetDocumentStatesByLabel;